import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="score-modal"
//
// Abre el modal "Criterios de valoración del Broker" al hacer click en el icono
// de info (ⓘ) de la puntuación de la plantilla `mejores` (tabla resumen, card de
// broker y destacado del mes). Sustituye al patrón compartido
// `components/_dialog_trigger.haml` SOLO para estos tres disparadores de
// `mejores`, por dos motivos:
//
//   1. Turbo-safe: aquel partial engancha el click en `DOMContentLoaded`, que no
//      se vuelve a disparar en navegaciones Turbo, así que el ⓘ no abría el modal
//      al llegar al artículo navegando dentro del sitio. Un controlador Stimulus
//      conecta en CADA carga (incluidas las Turbo).
//   2. Sin interpolar HTML en un literal JS: el contenido del modal viaja por un
//      Stimulus value (`content-value`, atributo `data-*` escapado por Rails), en
//      vez de inyectarse dentro de `new Dialog('...')` —frágil ante comillas o
//      saltos de línea—.
//
// Sigue siendo lazy: el `<dialog-modal>` solo se crea en el click (`window.Dialog`
// de `popbox.js`, ya cargado vía `layouts/_common_head`), por lo que no se
// renderiza markup de modal inline (la fuga que motivó la degradación a tooltip
// en la ronda 01 no es posible).
export default class extends Controller {
  static values = { content: String, options: Object }

  open (event) {
    event.preventDefault()
    // `popbox.js` define `window.Dialog` y se carga vía `layouts/_common_head`,
    // pero guardamos por si el controlador conectara en un contexto sin esa
    // dependencia (página sin `_common_head`, test JS aislado): mejor un no-op
    // silencioso que un TypeError sin feedback al usuario.
    if (typeof window.Dialog === 'undefined') return
    new window.Dialog(this.contentValue, this.optionsValue)
  }
}
